<template>
  <div class="footer_box">
    <div>Copyright © 2024 苏州来吧科技有限公司 版权所有
     <br>
      <a target="_blank" href="https://beian.miit.gov.cn" >
        <div >苏ICP备2024094573号-2A</div>
      </a>
      </div>
    </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less">
.footer_box {
  width: 100%;
  height: 80px;
  padding-top: 30px;
  background: #333333;
  //position: relative;
  color: #ccc;
  font-size: 14px;
  text-align: center;
}
.beian-span {
  float:left;
  height:20px;
  margin:6px 0px 0px 5px;
  color: #b3d3fa;
}
</style>